export default "__VITE_PUBLIC_ASSET__41e4a152__"